<template>
  <div class="koc-block koc-purchase-coupon-block">
    <div class="koc-full">
      <div class="koc-input">
        <form-input-component
          name="coupon"
          type="text"
          label="Enter Promotion Code"
          :value="state.coupon"
          @update="state.update"
        />
      </div>

      <div class="koc-submit">
        <button
          class="koc-button koc-ripple"
          :disabled="!state.coupon"
          @click="validate"
        >
          Apply
        </button>
      </div>
    </div>
  </div>
</template>

<script src="./coupon.js"></script>
<style lang="scss" scoped src="./coupon.scss"></style>